/*
 * @Author: zhangcheng
 * @Date: 2019-05-27 09:15:16
 * @Last Modified by: zhangcheng
 * @Last Modified time: 2019-06-06 16:58:17
 */
import React from 'react';
import Cookies from 'js-cookie';
import { Popconfirm, message, Divider } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import UserAdd from './components/UserAdd';
import { post, postFrom, config } from '../../axios';
import { dicMerchantUserStatus } from '../../axios/dictionaries';
import {fetchHouseKeepSendSignSms} from "../../services/housekeep";
import {API_merchantuser_editMerchantUserStatus} from "../../axios/config";

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: {
                keyword: '', //关键字
                pageSize: 10
            }, //搜索参数
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
            createOrEdit: false, //默认为创建
            departmentOptionData: [], //部门列表容器
            merchantIdOptionData: [], //商户列表容器
            isMerchant: false, //判断是否为商户显示新增
            merchantId: '', //当前商户id
        }
        this.handleNewAdd = this.handleNewAdd.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
            createOrEdit,
            departmentOptionData,
            merchantIdOptionData,
            isMerchant,
            merchantId
        } = this.state;

        let nowSearchData = [].concat(searchData({ merchantIdOptionData, departmentOptionData, handleChange: this.handleChange,handleSendSms:this.handleSendSms,handleUpdateStatus:this.handleUpdateStatus }));
        let findPageData = [].concat(columns({ current, handleEdit: this.handleEdit, handleDelete: this.handleDelete, isMerchant,handleSendSms:this.handleSendSms,handleUpdateStatus:this.handleUpdateStatus }));
        if (isMerchant) { //商户
            nowSearchData.splice(0, 1);
            findPageData.splice(4, 1);
        }

        return (
            <PageWrap
                loading={loading}
            >
                <div className={`search-wrapper ${isMerchant ? "" : "flex-justify-end"}`}>
                    {
                        isMerchant ?
                            <div className="search-btn-list">
                                <AuthButton authkey="h-3-2" type="primary" icon="plus" onClick={this.handleNewAdd}>新增</AuthButton>
                            </div>
                            : ''
                    }
                    <SuperForm
                        data={nowSearchData}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    // showCancel={isMerchant ? "重置" : false}
                    />
                </div>
                <TableDOM
                    columns={findPageData}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <UserAdd
                    onRef={ref => this.userAddRef = ref}
                    visible={showAddModal}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    departmentList={departmentOptionData}
                    parentMerchantId={merchantId}
                />
            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch();
        this.merchanttListsQuery();
        if (Cookies.get('loginData')) {
            let loginData = JSON.parse(Cookies.get('loginData'))
            for (let key in loginData) {
                if (key == 'merchantId' && loginData[key]) { //商户
                    this.handleChange(loginData["merchantId"]); //如果是商户，直接查询当前部门信息
                    this.setState({ isMerchant: true, merchantId: loginData[key] })
                }
            }
        }
    }

    handleEdit = (id, platformisAdmin) => { //编辑
        this.setState({ showAddModal: true, createOrEdit: true })
        this.userAddRef.loadRole(false);
        this.userAddRef.loadPack({ id, platformisAdmin })
        this.userAddRef.initPack();
    }

    handleNewAdd() { //新增
        this.setState({ showAddModal: true, createOrEdit: false })
        this.userAddRef.loadRole(true);
        this.userAddRef.loadDepartmentQuery(this.state.merchantId, 0);
        this.userAddRef.initPack();
    }

    handleDelete = (id) => { //删除

        this.setState({ loading: true });
        let data = { merchantuserId: id };
        postFrom({
            url: config.API_merchantuser_delMerchantUser,
            data,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.code) {
                message.error(res.message || '接口异常');
                return;
            }
            this.handleSearch();
            message.success(`删除成功`);
        }).catch(err => {
            message.error(err.message || '接口异常');
            this.setState({ loading: false });
        })
    }

    handleUpdateStatus = (id,status) => { //修改状态

        this.setState({ loading: true });
        let data = { id: id,status:status };
        post({
            url: config.API_merchantuser_editMerchantUserStatus,
            data,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.code) {
                message.error(res.message || '接口异常');
                return;
            }
            this.handleSearch();
            message.success(`状态变更成功`);
        }).catch(err => {
            message.error(err.message || '接口异常');
            this.setState({ loading: false });
        })
    }

    merchanttListsQuery = () => { //商户列表查询

        postFrom({
            url: config.API_merchant_findAll,
            data: {}
        }).then(res => {
            let result = [];
            for (let key in res) {
                result.push({
                    title: res[key]['name'],
                    value: res[key]['id']
                })
            }
            this.setState({ merchantIdOptionData: result });
        }).catch(err => {
            message.error(err.message || '获取商户列表失败');
        })
    }


    handleChange(value) { //选中商户查询部门列表

        postFrom({
            url: config.API_merchantdepartment_findAll,
            data: {
                merchantId: value
            }
        }).then(res => {
            let result = [];
            for (let key in res) {
                result.push({
                    title: res[key]['name'],
                    value: res[key]['id']
                })
            }
            this.setState({ departmentOptionData: result });
        }).catch(err => {
            message.error(err.message || '获取部门列表失败');
            this.setState({ loading: false });
        })
    }

     handleSendSms= (id) => {
        fetchHouseKeepSendSignSms({id}).then(() => {
            message.success('发送成功')
        })
    }

    handleSearch = (values = {}) => { //表单搜索/分页

        let { params, current, merchantId } = this.state;
        let data = {};
        let valueMerchantId = values.merchantId;
        let nowMerchantId = !merchantId ? 0 : merchantId;
        values.merchantId = !valueMerchantId || valueMerchantId == -1 ? nowMerchantId : values.merchantId;
        values.merchantDepartmentId = !values.merchantDepartmentId || values.merchantDepartmentId == -1 ? '' : values.merchantDepartmentId;
        delete params.departmentId;
        if (values.current) {
            data = Object.assign(params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({
            url: config.API_merchantuser_findPage,
            data,
        }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }
}

const searchData = ({ merchantIdOptionData, departmentOptionData, handleChange }) => [

    {
        tagName: 'Select',
        formConfig: { name: 'merchantId' },
        attribute: {
            placeholder: '请选择商户', style: { width: '160px' }, onChange: (value) => {
                handleChange(value)
            }
        },
        optionData: merchantIdOptionData
    },
    {
        tagName: 'Select',
        formConfig: { name: 'merchantDepartmentId' },
        attribute: { placeholder: '请选择部门', style: { width: '160px' } },
        optionData: departmentOptionData
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字 ', style: { width: '160px' } },
        title: '在姓名/手机号内模糊查询'
    },
];
const columns = ({ current, handleEdit, handleDelete, isMerchant,handleSendSms,handleUpdateStatus }) => [
    {
        title: '名称',
        dataIndex: 'name'
    },
    {
        title: '手机号码',
        dataIndex: 'phone'
    },

    {
        title: '岗位',
        dataIndex: 'roleName'
    },
    {
        title: '使用状态',
        dataIndex: 'status',
        render(text, record, index) {

            let now = dicMerchantUserStatus.find(item => item.value == text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '商户',
        dataIndex: 'merchantName'
    },
    {
        title: '部门',
        dataIndex: 'departmentName'
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (<div>
                { record.roleName!='驻点管家'?<AuthButton authkey="h-3-3"><span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span></AuthButton>:null}
                    {
                        // 已签约 不需要发送签约短信
                        record.signStatus !== 2 && (
                            <AuthButton authkey="h-3-5">
                                <Divider type="vertical" />
                                <Popconfirm title="确认发送吗?" onConfirm={() => handleSendSms(record.id)}>
                                    <span className="showClickDetail">发送签约短信</span>
                                </Popconfirm>
                            </AuthButton>
                        )
                    }
                    {
                        record.isAdmin|| record.roleName=='驻点管家' ?
                        null :
                        <React.Fragment>
                            <Divider type="vertical" />
                            <AuthButton authkey="h-3-4">
                                <Popconfirm placement="top" title={"确定删除吗？"} onConfirm={() => { handleDelete(record.id) }} okText="确定" cancelText="不了">
                                    <span className="showClickDetail">删除</span>
                                </Popconfirm>
                            </AuthButton>
                        </React.Fragment>
                    }
                {
                    record.status !== 1?
                    <React.Fragment>
                        <Divider type="vertical"/>
                        <AuthButton authkey="h-3-6">

                            <Popconfirm placement="top" title={"确定启用吗？"} onConfirm={() => {
                                handleUpdateStatus(record.id,1)
                            }} okText="确定" cancelText="不了">
                                <span className="showClickDetail">启用</span>
                            </Popconfirm>
                        </AuthButton>
                    </React.Fragment>
                        : <React.Fragment>
                            <Divider type="vertical"/>
                            <AuthButton authkey="h-3-6">
                                <Popconfirm placement="top" title={"确定停用吗？"} onConfirm={() => {
                                    handleUpdateStatus(record.id,2)
                                }} okText="确定" cancelText="不了">
                                    <span className="showClickDetail">停用</span>
                                </Popconfirm>
                            </AuthButton>
                        </React.Fragment>
                }
            </div>)
        }
    }
];



// WEBPACK FOOTER //
// ./src/page/Merchant/User.js